import { render, staticRenderFns } from "./VoyagePanel.vue?vue&type=template&id=53b08e26"
import script from "./VoyagePanel.vue?vue&type=script&lang=js"
export * from "./VoyagePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports